
















































import {Component, Prop} from 'vue-property-decorator';
import store from "@/stores/store";
import {UserRole} from "@/interfaces/user";
import DocumentFormModal from "@/components/document/document-form-modal.vue";
import {Order} from "@/interfaces/order";
import {Reception} from "@/interfaces/reception";
import {documentApiProvider} from "@/providers/document-api-provider";
import {AgGridVue} from "ag-grid-vue";
import {MainGedGrid} from "@/utils/grid/main-ged-grid";
import GridIconRowComponent
  from "@/components/_shared/grid-components/grid-cells/grid-icon-row-component.vue";
import ConfirmModal from "@/components/_shared/modals/confirm-modal.vue";

@Component({
  name: "document-detail-list",
  computed: {},
  components: {ConfirmModal, AgGridVue, DocumentFormModal, GridIconRowComponent}
})
export default class DocumentDetailList extends MainGedGrid {
  @Prop() data: Order|Reception;
  @Prop() dataType: string;

  documents = [];

  $refs: {
    documentFormModal: HTMLFormElement;
  };

  superAdmin = store.getters["user/getUser"].role == UserRole.superadmin;

  columns = [...this.getGridField(), this.superAdmin ? this.getActionField() : {}]

  async beforeMount() {
    await this.fetcDocuments();
    super.beforeMount();
    this.gridOptions.getRowClass = function (params: any) {
      if (params.data && !params.data.active) {
        return "kDartessRed25";
      }
    };
  }

  async fetcDocuments() {
    this.documents = await documentApiProvider.getMyDocuments(this.data.id, this.dataType);
  }
}
